import gql from 'graphql-tag'

export const CREATE_PRESET_GROUP = gql`
  mutation CreatePresetGroup($name: String!) {
    createPresetGroup(data: { name: $name }) {
      id
      name
    }
  }
`

export const UPDATE_PRESET_GROUP = gql`
  mutation UpdatePresetGroup($id: Int!, $name: String!) {
    updatePresetGroup(id: $id, data: { name: $name }) {
      id
      name
    }
  }
`

export const DELETE_PRESET_GROUP = gql`
  mutation DeletePresetGroup($id: Int!) {
    deletePresetGroup(id: $id) {
      id
    }
  }
`
